import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  a {
    text-decoration: none;
    transition: all .3s ease;

    &:hover {
     font-weight: bold;
    }
  }
`;
